import React from 'react';
import Button from 'react-bootstrap/Button';
import { Spacing } from '_styles';

const RegisterTileButton = (props) => {

    return (
        <Button variant="primary" style={{ width: 300, height: 350, borderRadius: 10, boxShadow: "0px 4px 8px 0px #9E9E9E", marginLeft: 10, alignItems: 'center', textAlign: 'center' }} onClick={props.onClick}>

            {/* Title */}
            <div style={{ display: 'flex', padding: 5, textAlign: 'center', marginBottom: Spacing.SCALE_22 }}>
                <p style={{ fontSize: 32, fontWeight: 'bold', textAlign: 'center', marginTop: 18, marginLeft: 22 }}>{props.title}</p>
            </div>

            {/* Image */}
            <div style={{ textAlign: 'center', alignItems: 'center', justifyContent: 'center', marginLeft: Spacing.SCALE_18 }}>
                {props.icon}
            </div>

            {/* Text */}
            <div style={{ marginTop: 16, padding: 5, display: 'flex', justifyContent: 'space-between' }}>
                <p style={{ fontSize: 24, fontWeight: '200' }}>{props.text}</p>
                {props.lowerIcon}
            </div>

        </Button>
    );

}

export default RegisterTileButton;
